import { useEffect } from 'react'

import { Loading, ToastContainer } from 'mailup-web-components'
import { ModalConfirmLeave } from 'Pages/TemplateEdit/ModalConfirmLeave'
import ModalSave from 'Pages/TemplateEdit/ModalSave'
import { ModalThirdParty } from 'Pages/TemplateEdit/ModalThirdParty'
import { pageErrorState, pageState } from 'Pages/TemplateEdit/recoil/state/page'
import {
  useRecoilCallback,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState
} from 'recoil'

import Header from './Header'

import ModalAiAssistantBee from 'Components/ModalAiAssistantBee'
import ModalContentDefaults from 'Components/ModalContentDefaults/ModalContentDefaults'
import ModalOfferLightUpsell from 'Components/ModalOfferLightUpsell'
import { notifyParent } from 'mailup-react-helpers'
import ErrorFeedback from 'Pages/TemplateEdit/ErrorFeedback'
import ModalError from 'Pages/TemplateEdit/ModalError/ModalError'

import { modalOfferLightUpsellState } from 'Pages/TemplateEdit/recoil/state/modals'
import { useHistory, useParams } from 'react-router-dom'
import BeePluginEditor from './BeePluginEditor'
import { ModalBeeSavedRow } from './ModalBeeSavedRow/ModalBeeSavedRow'
import { getTotalTokensCountCallback } from './recoil/callbacks/callbacks'
import { editorState, openAIState } from './recoil/state/editor'

export const TemplateEdit = () => {
  const params = useParams()
  const { loading } = useRecoilValue(pageState)
  const { error } = useRecoilValue(pageErrorState)
  const { idNewTemplate } = useRecoilValue(editorState)
  const history = useHistory()
  const { showBuy } = useRecoilValue(openAIState)
  const setEditorState = useSetRecoilState(editorState)

  const getTotalTokensCount = useRecoilCallback(getTotalTokensCountCallback, [])
  const { show: showModalOfferLightUpsell } = useRecoilValue(
    modalOfferLightUpsellState
  )
  const closeModalOfferLightUpsell = useResetRecoilState(
    modalOfferLightUpsellState
  )

  useEffect(() => {
    setEditorState(prev => ({
      ...prev,
      kind: params.kind,
      mode: params.mode
    }))

    notifyParent('setFullScreen', [true])
    getTotalTokensCount()
    return () => {
      notifyParent('setFullScreen', [false])
    }
  }, [])

  useEffect(() => {
    if (idNewTemplate > 0 && params.mode !== 'copy') {
      const route = `/templates/bee/${params.mode}/${idNewTemplate}`
      history.push(route)
    }
  }, [idNewTemplate])

  return (
    <>
      <Loading open={loading} />
      <ToastContainer />
      <ModalThirdParty />
      <ModalConfirmLeave />
      <ModalSave />
      <ModalError />
      <ModalContentDefaults />
      <ModalAiAssistantBee showBuy={showBuy} />
      <ModalBeeSavedRow />
      <ModalOfferLightUpsell
        show={showModalOfferLightUpsell}
        onClose={closeModalOfferLightUpsell}
      />
      <Header />
      <div className='l-container'>
        <ErrorFeedback />
      </div>
      {!error && (
        <>
          <BeePluginEditor idNewTemplate={idNewTemplate} />
        </>
      )}
    </>
  )
}

export default TemplateEdit
